import { FC } from 'react';

import { Wrapper, Image } from './styles';

type TBannerCategory = {
  banners?: {
    desktop: string;
    mobile: string;
  };
};

export const BannerCategory: FC<TBannerCategory> = ({ banners }) => {
  if (!banners) return null;

  return (
    <Wrapper>
      <Image src={banners.desktop} alt="Category banner" />
    </Wrapper>
  );
};
